import { ConfigService } from '@/configuration/services/configService';

/** Отладочные средства (меню «Инструменты», системные имена полей, схема таблицы): вне PROD — всем, на PROD — с AdminPanel. */
export const canSeeDebugTools = (canViewAdminPanel: boolean | undefined): boolean =>
    !!canViewAdminPanel || ConfigService.get().environment !== 'PROD';
